module.exports = __webpack_public_path__ + "img/youtube.842b92a4.svg";